// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-about-page-js": require("gatsby-module-loader?name=component---src-templates-about-page-js!/opt/build/repo/src/templates/about-page.js"),
  "component---src-templates-blog-post-js": require("gatsby-module-loader?name=component---src-templates-blog-post-js!/opt/build/repo/src/templates/blog-post.js"),
  "component---src-templates-product-page-js": require("gatsby-module-loader?name=component---src-templates-product-page-js!/opt/build/repo/src/templates/product-page.js"),
  "component---src-templates-tags-js": require("gatsby-module-loader?name=component---src-templates-tags-js!/opt/build/repo/src/templates/tags.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-tags-index-js": require("gatsby-module-loader?name=component---src-pages-tags-index-js!/opt/build/repo/src/pages/tags/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "about.json": require("gatsby-module-loader?name=path---about!/opt/build/repo/.cache/json/about.json"),
  "blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week.json": require("gatsby-module-loader?name=path---blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week!/opt/build/repo/.cache/json/blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week.json"),
  "products.json": require("gatsby-module-loader?name=path---products!/opt/build/repo/.cache/json/products.json"),
  "tags-intro.json": require("gatsby-module-loader?name=path---tags-intro!/opt/build/repo/.cache/json/tags-intro.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "tags.json": require("gatsby-module-loader?name=path---tags!/opt/build/repo/.cache/json/tags.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js